<template>
  <div class="partner-offer-card">
    <div class="partner-offer-card__inner">
      <div
        class="partner-offer-card__logo-wrap"
      >
        <img
          class="partner-offer-card__logo"
          :src="offer.logo"
          :alt="offer.companyName"
        >
      </div>
      <div
        v-if="offer.note"
        class="partner-offer-card__text"
        v-html="offer.note"
      />
      <div v-else class="partner-offer-card__text-empty">
        Нет текста
      </div>
      <a
        :href="hrefOffer"
        class="partner-offer-card__btn"
      >
        Подробнее
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PartnerOfferCard',
  props: {
    offer: {
      type: Object,
      required: true,
    },
  },
  computed: {
    hrefOffer() {
      return `${window.location.pathname}/${this.offer.slug}`;
    },
  },
};
</script>

<style lang="scss">
.partner-offer-card {
  position: relative;
  display: flex;
  flex-grow: 1;
  min-height: 250px;

  &:before {
    content: '';
    position: absolute;
    top: 27px;
    left: 12px;
    right: 12px;
    bottom: -21px;
    background: rgba(0, 0, 0, 0.06);
    filter: blur(20px);
  }
  &:hover {
    &:before {
      background: rgba(0, 0, 0, 0.15);
    }
  }
}
.partner-offer-card__inner {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  position: relative;
  padding: 25px 25px 29px 20px;
  background: #FFFFFF;
  border-radius: 4px;
}
.partner-offer-card__logo-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  margin-bottom: 10px;
}
.partner-offer-card__logo {
  max-height: 50px;
}
.partner-offer-card__text {
  margin-top: auto;
  margin-bottom: 14px;
  min-height: 38px;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #333;
  span {
    font-size: 20px;
    color: #FF1B4C;
  }
}
.partner-offer-card__text-empty {
  margin-top: auto;
  margin-bottom: 14px;
  font-weight: normal;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  color: #999;
}
.partner-offer-card__btn {
  margin-top: auto;
  padding: 9px 10px 10px 9px;
  width: 100%;
  max-width: 400px;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: #333333;
  border: 1px solid #D2D2D2;
  background-color: transparent;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
  transition: .3s all cubic-bezier(.4,0,.6,1);
  &:hover {
    border-color: #FF1B4C;
    background-color: #FF1B4C;
    color: #fff;
  }
  &:focus {
    outline: none;
  };
}
</style>
